/**
 * Brand logo (gold KS+DevArc mark) on a transparent background, so it
 * sits cleanly on both themes without a dark badge.
 */
export default function Logo({ variant = "full", className = "" }) {
  const h =
    variant === "icon" ? "h-8 w-8" : variant === "compact" ? "h-7" : "h-9";
  return (
    <span
      data-testid="brand-logo"
      className={`inline-flex items-center justify-center ${className}`}
    >
      <img
        src="/logo.png"
        alt="KS DevArc"
        className={`${h} w-auto object-contain select-none`}
        draggable="false"
      />
    </span>
  );
}
